import { EC, DC } from "./general";
let access_token_name = "accessToken";
export default {
  set: (name, val) => {
    return window.localStorage.setItem(name || access_token_name, val);
  },
  get: token => {
    return window.localStorage.getItem(token || access_token_name);
  },
  remove: token => {
    return window.localStorage.removeItem(token || access_token_name);
  },
  check: token => {
    if (token) {
      return Boolean(window.localStorage.getItem(token));
    } else {
      return Boolean(window.localStorage.getItem(access_token_name));
    }
  }
};
